module.exports = __webpack_public_path__ + "img/clock.173ff98b.svg";